import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { TextLoading } from '../../../../../../../../CommonComponents/OPL/Text/Text.loading';

interface Props {
  planNames: string[];
}

export const TableRowLoading: React.FC<Props> = ({ planNames }) => {
  return (
    <Box as="tr">
      <Box as="td" p="16">
        <TextLoading width={130} height="h6" />
      </Box>

      {planNames.map(planId => (
        <Box key={planId} as="td" p="16">
          <TextLoading width={105} height="h4" mx="auto" />
        </Box>
      ))}
    </Box>
  );
};
